import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { MemberInsurerServiceService } from '@app/modules/lps-member-login/services/member-insurer-service.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private router: Router,
    private memberInsurerService: MemberInsurerServiceService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const isLoggedIn = this.memberInsurerService.isUserLoggedIn() === 'true';
    const role = this.memberInsurerService.getLoginUserRole();
    const userAccess = this.memberInsurerService.getUserAccess();
    const currentUrl = state.url;

    if (!isLoggedIn) {
      // Redirect based on role + userAccess
      if (role === 'PROVIDER') {
        const target = userAccess === 'ADMIN_PROVIDER' ? '/login/adminProvider' : '/login/provider';
        this.router.navigate([target]);
      } else if (role === 'INSURER') {
        const target = userAccess === 'ADMIN_INSURER' ? '/login/adminInsurer' : '/login/insurer';
        this.router.navigate([target]);
      } else {
        this.router.navigate(['/login']); // fallback
      }
      return false;
    }

    // Restrict INSURER from accessing PROVIDER routes
    if (role === 'INSURER' && currentUrl.includes('/provider')) {
      this.memberInsurerService.clearLoginUserRole();
      this.router.navigate(['/login/insurer']);
      return false;
    }

    // Restrict PROVIDER from accessing INSURER routes
    if (role === 'PROVIDER' && currentUrl.includes('/insurer')) {
      this.memberInsurerService.clearLoginUserRole();
      this.router.navigate(['/login/provider']);
      return false;
    }

    return true; // ✅ Allow route if all checks pass
  }
}
